export default {
    setCurrentFD(state, payload) {
        state.currentFD = payload
    },
    setFDs(state, payload) {
        state.fds = payload
    },
    appendPastFDs(state, payload) {
        state.pastFDs = state.pastFDs ? [...state.pastFDs, ...payload] : payload;
    },
    setPastFDCursor(state, doc) {
        state.lastPastFDDoc = doc;
    },
    setHasMorePastFDs(state, value) {
        state.hasMorePastFDs = value;
    },
    setLiveFD(state, fd) { state.liveFD = fd; },
    setFDError(state, message) { state.fdError = message; }
}